import { StateCreator } from 'zustand'
import { InviteLinksState } from '../state'
import {
    TrafficSourceOptionType,
    DetalizationOptionType,
    UsersSortOptionType,
    typedUsersSortOptions,
    typedDetalizationSortOptions,
    typedTrafficSourceSortOptions,
    SubscriberStatusSortOptionType,
    typedSubscriberStatusSortOptions,
} from '../../constants'
import { SelectedGroupsType } from '../types'

export interface RetentionGroupsSlice {
    trafficSourceSortRetentionGroup: TrafficSourceOptionType
    detalizationSortRetentionGroup: DetalizationOptionType
    usersSortRetentionGroup: UsersSortOptionType
    subscriberStatusSortRetentionGroup: SubscriberStatusSortOptionType
    startDateRetentionGroup: string
    endDateRetentionGroup: string
    selectedRetentionGroups: SelectedGroupsType
    setStartDateRetentionGroup: (value: string) => void
    setEndDateRetentionGroup: (value: string) => void
    setTrafficSourceSortRetentionGroup: (value: TrafficSourceOptionType) => void
    setDetalizationSortRetentionGroup: (value: DetalizationOptionType) => void
    setUsersSortRetentionGroup: (value: UsersSortOptionType) => void
    setSubscriberStatusSortRetentionGroup: (
        value: SubscriberStatusSortOptionType
    ) => void
    toggleSelectedRetentionGroup: (
        channelId: number,
        group: number,
    ) => void
}

export const createRetentionGroupsSlice: StateCreator<
    InviteLinksState,
    [],
    [],
    RetentionGroupsSlice
> = (set) => ({
    trafficSourceSortRetentionGroup: typedTrafficSourceSortOptions[0],
    detalizationSortRetentionGroup: typedDetalizationSortOptions[0],
    usersSortRetentionGroup: typedUsersSortOptions[0],
    subscriberStatusSortRetentionGroup: typedSubscriberStatusSortOptions[0],
    selectedRetentionGroups: {},
    startDateRetentionGroup: '',
    endDateRetentionGroup: '',

    setStartDateRetentionGroup: (value) =>
        set({ startDateRetentionGroup: value }),
    setEndDateRetentionGroup: (value) => set({ endDateRetentionGroup: value }),
    setTrafficSourceSortRetentionGroup: (value) =>
        set({ trafficSourceSortRetentionGroup: value }),
    setDetalizationSortRetentionGroup: (value) =>
        set({ detalizationSortRetentionGroup: value }),
    setUsersSortRetentionGroup: (value) =>
        set({ usersSortRetentionGroup: value }),
    setSubscriberStatusSortRetentionGroup: (value) =>
        set({ subscriberStatusSortRetentionGroup: value }),

    toggleSelectedRetentionGroup: (channelId: number, groupId: number) => {
        set((state) => {
            let selected = state.selectedRetentionGroups[channelId] || []
            if (selected.includes(groupId)) {
                selected = selected.filter(
                    (id) => id !== groupId
                )
            } else {
                selected = [...selected, groupId]
            }
            return {
                selectedRetentionGroups: {
                    ...state.selectedRetentionGroups,
                    [channelId]: selected,
                },
            }
        })
    },
    clearSelectedRetentionGroupsByChannel: (channelId: number) => {
        set((state) => ({
            selectedRetentionGroups: {
                ...state.selectedRetentionGroups,
                [channelId]: [],
            },
        }))
    },
})
